import LoadingBox from 'components/Common/Loading/LoadingBox'
import React from 'react'
import useBusinessTravellerSocieteDetailsFetcher from 'businessTraveller/hooks/useBusinessTravellerSocieteDetailsFetcher'
import useSocieteCampaign from 'loyalty/hooks/useSocieteCampaign'
import { LEBT_SOCIETE_CAMPAIGN_SLUG } from 'loyalty/constants/loyaltyRoutes'
import { isAtOrAboveLoyaltyTier } from 'loyalty/utils/isAtOrAboveLoyaltyTier'
import SocieteCampaignTierCardContent from './SocieteCampaignTierCardContent'
import useSocieteCampaignTargetTier from 'loyalty/hooks/useSocieteCampaignTargetTier'

interface Props {
  onLearnMoreClick?: () => void
}

function SocieteCampaignTierCard(props: Props) {
  const { onLearnMoreClick } = props
  const campaign = useSocieteCampaign(LEBT_SOCIETE_CAMPAIGN_SLUG)
  const { targetTier } = useSocieteCampaignTargetTier()
  const { isFetching: isFetchingSocieteDetails, societeTierSetting, linkedCreditAccount } = useBusinessTravellerSocieteDetailsFetcher(targetTier)

  if (isFetchingSocieteDetails) {
    return <LoadingBox height={280} borderRadius="L" />
  }

  const isAtOrAboveGold = isAtOrAboveLoyaltyTier(linkedCreditAccount?.tier, targetTier)

  // Hide once the campaign is not enabled, or the user is already at Société Gold or above, or there is no campaign with a secondary section in state
  if (!societeTierSetting?.enabled || isAtOrAboveGold || !campaign) return null

  return <SocieteCampaignTierCardContent
    campaign={campaign}
    targetTier={targetTier}
    societeTierSetting={societeTierSetting}
    linkedCreditAccount={linkedCreditAccount}
    onLearnMoreClick={onLearnMoreClick}
  />
}

export default SocieteCampaignTierCard
